import React, { useState } from "react";
import PropTypes from "prop-types";
import { EditArrow } from "styles/globalSVG";
import { Badge, styled } from "@mui/material";
import { makeStyles } from '@mui/styles';
import MyTeams from "./teams/MyTeams";
import InvitesReceived from "./invitations/InvitesReceived";
import TeamApplicationsSent from "./invitations/TeamApplicationsSent";

const useStyles = makeStyles({
  mobileContainer: {
    maxWidth: "21.5rem",
    backgroundColor: "white",
    marginTop: "4rem",
    margin: "auto",
  },
  mobileTeamPageContainer: {
    listStyleType: "none",
    margin: "0.8rem 0",
    padding: "0 1rem 0.8rem",
    borderBottom: "1px solid #D8D8D8",
    backgroundColor: "white",
    "&:last-child": {
      borderBottom: "none",
      paddingBottom: "0",
    },
  },
  arrow: {
    float: "right",
    "&[disabled]": {
      display: "none",
    },
  },
  titleStyle: {
    display: "inline-block",
    color: "rgba(0, 27, 17, 0.7)",
    width: "240px",
    "&[disabled]": {
      color: "#D8D8D8 ",
      pointerEvents: "none",
    },
  },
  badgeStyle: {
    marginLeft: "1rem",
  },
});

const ProfileOption = styled("div")({
  border: "1px solid rgba(0, 27, 17, 0.1)",
  borderRadius: "4px",
  width: "310px",
  margin: "auto",
});

const ProfilePage = ({ title, children, editable, badge, userInvites }) => {
  const classes = useStyles();
  const [showChildren, setShowChildren] = useState(false);
  const rotate = showChildren ? "rotate(90deg)" : "rotate(0)";

  return (
    <div className={classes.mobileTeamPageContainer}>
      <div
        onClick={() => setShowChildren(!showChildren)}
        className={classes.titleStyle}
        disabled={!editable}
        role="button"
      >
        {title}
        {badge && (
          <Badge
            color="error"
            className={classes.badgeStyle}
            badgeContent={userInvites.length}
            max={99}
            variant="default"
          />
        )}
      </div>
      <div
        className={classes.arrow}
        onClick={() => setShowChildren(!showChildren)}
        style={{ transform: rotate, transition: "all 0.2s linear" }}
        disabled={!editable}
        role="button"
        aria-label="Toggle children"
      >
        <EditArrow />
      </div>
      {showChildren && children}
    </div>
  );
};

const DashboardMobile = (props) => {
  const {
    myTeams,
    myTeamCredits,
    joinTeams,
    subTeams,
    pastedTeams,
    myInvites,
    hasReceivedInvites,
    fetchInviteData,
    loadingApplication,
    hasSentApps,
    teamApplications,
    userInvites,
    showMemberTeams,
    showPastTeams,
    publicUser,
    userData,
    publicShowMembership,
    pubMembership,
    isVerified,
  } = props;
  const classes = useStyles();

  // Filter out subteams
  const filteredMyTeams = myTeams.filter(team => team.Team.type !== 'simple sub-team');
  const filteredJoinTeams = joinTeams.filter(team => team.Team.type !== 'simple sub-team');

  return (
    <div className={classes.mobileContainer}>
      <ProfileOption>
        {!publicUser ? (
          <ProfilePage title="Managed" editable={true}>
            <MyTeams
              myTeams={filteredMyTeams}
              isVerified={isVerified}
              myTeamCredits={myTeamCredits}
            />
          </ProfilePage>
        ) : (
          <ProfilePage title="Managed" editable={true}>
            <MyTeams
              myTeams={userData.Teams}
              visitor={publicUser}
              myTeamCredits={myTeamCredits}
              isVerified={isVerified}
            />
          </ProfilePage>
        )}
        {!publicUser ? (
          <ProfilePage title="Joined" editable={showMemberTeams}>
            <MyTeams myTeams={filteredJoinTeams} myTeamCredits={null} />
          </ProfilePage>
        ) : (
          <ProfilePage title="Joined" editable={showMemberTeams}>
            <MyTeams
              myTeams={pubMembership[0]}
              visitor={publicUser}
              myTeamCredits={null}
            />
          </ProfilePage>
        )}
        <ProfilePage
          title="Sub Teams"
          editable={showMemberTeams}
        >
          <MyTeams myTeams={subTeams} myTeamCredits={null} isSubTeam={true} />
        </ProfilePage>
        <ProfilePage
          title="Invitations"
          editable={hasReceivedInvites}
          badge={true}
          userInvites={userInvites}
        >
          <InvitesReceived
            myInvites={myInvites}
            hasReceivedInvites={hasReceivedInvites}
            fetchInviteData={fetchInviteData}
          />
        </ProfilePage>
        <ProfilePage title="Applications" editable={hasSentApps}>
          <TeamApplicationsSent
            loadingApplication={loadingApplication}
            hasSentApps={hasSentApps}
            teamApplications={teamApplications}
          />
        </ProfilePage>
        <ProfilePage title="Past Teams" editable={showPastTeams}>
  {pastedTeams && pastedTeams.length > 0 ? (
    <MyTeams myTeams={pastedTeams} myTeamCredits={null} />
  ) : (
    <p>No past teams found.</p>
  )}
</ProfilePage>
      </ProfileOption>
    </div>
  );
};

DashboardMobile.propTypes = {
  currentUser: PropTypes.object,
};

export default DashboardMobile;
